@if (!editMode) {
  <div>
    @if (imageSrc !== undefined) {
      <img [src]="imageSrc" class="small-image" />
    }
    @if (imageSrc === undefined) {
      <div>No Image</div>
    }
  </div>
}
